import "../../../../src/pages/design/design-guidelines-styles.css";
import { magma } from 'react-magma-dom';
import { ColorSwatch } from "../../../../src/components/ColorSwatch";
import * as React from 'react';
export default {
  magma,
  ColorSwatch,
  React
};